<template>
    <div class="product-container" v-loading="loadProduct">
        <div class="product-title">
            {{feed.title}}
        </div>
        <div class="feed-media" v-if="loadVideo">
            <video ref="videoPlayer" class="video-js vjs-big-play-centered" preload="auto" controls="controls">
                <source :src="feed.uriKey[0]" type="video/mp4">
            </video>
        </div>
        <div class="product-content">
            {{initProductContent}}
        </div>
        <div class="user-name">{{initUserName}}</div>
    </div>
</template>
<script>
import { apiMap } from '../../../utils/apiMap';
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import { videoChinese } from '../../../utils/common'; 
export default {
    name: 'relatice-video',
    props: {
        productId: Number,
    },
    data() {
        return {
            feed: {
                uriKey: ['']
            },
            loadProduct: true,
            player: null,
            options: {
                language: 'zh-CN',
            },
            loadVideo: false,
        }
    },
    computed: {
        initUserName() {
            if (this.feed.hasOwnProperty('userInfo')) {
                return `添加人： ${this.feed.userInfo.realName}`
            }else {
                return ''
            }
        },
        initProductContent() {
            if (this.feed.hasOwnProperty('introduction') && this.feed.introduction!='null') {
                return this.feed.introduction
            }else {
                return ''
            }
        }
    },
    beforeMount() {
        // console.log(this.feed)
        videojs.addLanguage('zh-CN', videoChinese);
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },
    methods: {
        getProductDetail() {
            // console.log(this.productId)
            // token modelId modelType=1 self=2 feedDetail
            let _this = this;
            let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
            _this.$axios({
                baseURL: apiMap['commonUrl'],
                method: apiMap['feedDetail']['method'],
                url: apiMap['feedDetail']['url'],
                params: {
                    token: loginUser.token,
                    modelId: _this.productId,
                    modelType: 4,
                    self: 2,
                } 
            }).then(function (response) {
                // console.log(response.data)
                // _this.feedShade = false;
                if (response.data.result.statusCode==1) {           
                    _this.feed = response.data.result.data;
                    _this.loadProduct = false;
                    _this.loadVideo = true;
                    setTimeout(() => {
                        _this.player = videojs(_this.$refs.videoPlayer, _this.options, function onPlayerReady() {});
                    }, 500);
                                 
                } else {

                }
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    watch: {
        productId() {
            this.loadProduct = true;
            this.loadVideo = false;
            this.getProductDetail();
        }
    }
}
</script>
<style scoped>
.product-container {
    min-height: 60px;
    padding: 15px 15px 15px 20px;
}

.product-title {
    line-height: 30px;
    font-weight: bold;
    font-size: 16px;
}

.product-content {
    font-size: 16px;
    line-height: 25px;
    white-space: pre-line;
}

.user-name {
    margin-top: 15px;
    color: #808080;
}

.feed-media {
    width: 650px;
    height: 380px;
    margin: 5px 0;
}

.feed-media .video-js {
    width: 100%; 
    height: 100%;
}
</style>